import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Row, Col, Avatar } from 'antd';
import Form from "react-jsonschema-form";
import isEmpty from 'lodash/isEmpty';
import { TextMessage, TextWithMedia, CarouselWithButtons, Recharge, RechargeDetails, Offers, RechargeHistory } from 'message-types';

import './index.scss';

import { IMG_CHAT_INTERFACE } from '../../../../data/assets/img';
import { showMessage, generateMessageObject, log } from '../../../../data/config/utils';
import { BRAND_INFO } from '../../../../data/config/urls';
import { MESSAGE_TYPES, MESSAGE_SUBTYPES } from '../../../../data/config/constants';

import ModalFooter from '../../../../components/modalfooter';
import ErrorBoundary from '../../../../components/errorboundary';

class BotMessageForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            bubble_message: {},
        }
    }

    componentDidMount() {
        const { form_data } = this.props;
        if (!isEmpty(form_data)) {
            this.updateBubbleMessage(form_data);
        }
    }

    updateBubbleMessage = (formData) => {
        const { context_variables_data } = this.props;
        const payload = {
            ...formData[formData.type],
            type: formData.type,
        };
        if (!isEmpty(context_variables_data)) {
            const bubble_message = generateMessageObject(payload, context_variables_data);
            this.setState({ bubble_message });
        }
    };

    handleFormDataError = (errors) => {
        if (errors) {
            errors.forEach((error) => {
                if (error.stack) {
                    showMessage('error', error.stack);
                }
            })
        }
    };

    handleFormDataChange = ({ formData }) => {
        log('form data changed', formData);
        this.props.updateMessageFormData(formData);
        this.updateBubbleMessage(formData);
    };

    render() {
        const { screen_height, screen_width, button_ok_text, schema, ui_schema, form_data, loading, handleOkClick, handleCancelClick } = this.props;
        const { bubble_message } = this.state;
        const mobile = screen_width < 768;
        const show_textMessage = bubble_message.type === MESSAGE_TYPES.TEXT;
        const show_textWithButtons = bubble_message.type === MESSAGE_TYPES.TEXT_WITH_BUTTONS;
        const show_imageWithButtons = bubble_message.type === MESSAGE_TYPES.IMAGE_WITH_BUTTONS;
        const show_textWithVideo = bubble_message.type === MESSAGE_TYPES.VIDEO;

        const show_textWithMedia = show_textWithButtons || show_imageWithButtons || show_textWithVideo;

        const show_carousel = bubble_message.type === MESSAGE_TYPES.CAROUSEL;
        const show_recharge = bubble_message.type === MESSAGE_TYPES.CUSTOM_MSG && bubble_message.payload.subtype === MESSAGE_SUBTYPES.DISH_RECHARGE;
        const show_rechargeDetails = bubble_message.type === MESSAGE_TYPES.CUSTOM_MSG && bubble_message.payload.subtype === MESSAGE_SUBTYPES.DISH_RECHARGE_DETAILS;
        const show_offers = bubble_message.type === MESSAGE_TYPES.CUSTOM_MSG && bubble_message.payload.subtype === MESSAGE_SUBTYPES.DISH_OFFERS;
        const show_rechargeHistory = bubble_message.type === MESSAGE_TYPES.CUSTOM_MSG && bubble_message.payload.subtype === MESSAGE_SUBTYPES.DISH_RECHARGE_HISTORY;

        return (
            <Row className="oriBotMessageFormContainer" style={{ height: mobile ? "" : `${screen_height - 60 - 40 - 40}px`, maxHeight: mobile ? '' : '1020px' }}>
                <Col xs={24} sm={24} md={12} className="ori-bg-default ori-lr-pad-20 ori-tb-pad-30 ori-overflow-x-hidden ori-overflow-y-auto ori-full-parent-height msgInterfaceContainer" style={{ backgroundImage: `url(${IMG_CHAT_INTERFACE})` }} >
                    {
                        (show_textMessage || show_textWithMedia || show_recharge || show_rechargeDetails || show_offers || show_rechargeHistory || show_carousel) &&
                        <ErrorBoundary>
                            <div className="ori-relative ori-flex msgBoxContainer">
                                <div className="ori-absolute ori-animated ori-zoom-in botAvatar">
                                    <Avatar src={BRAND_INFO.bot_icon_url} />
                                </div>

                                <div className="ori-animated ori-zoom-in ori-lr-pad-10 ori-tb-pad-7 ori-first-bubble-border-radius ori-bg-white ori-box-shadow-light msgBox">
                                    {
                                        show_textMessage &&
                                        <TextMessage message={bubble_message} />
                                    }
                                    {
                                        show_textWithMedia &&
                                        <TextWithMedia message={bubble_message} btn_disabled />
                                    }
                                    {
                                        show_recharge &&
                                        <Recharge message={bubble_message} btn_disabled />
                                    }
                                    {
                                        show_rechargeDetails &&
                                        <RechargeDetails message={bubble_message} btn_disabled />
                                    }
                                    {
                                        show_offers &&
                                        <Offers message={bubble_message} disable_offer btn_disabled />
                                    }
                                    {
                                        show_rechargeHistory &&
                                        <RechargeHistory message={bubble_message} btn_disabled />
                                    }
                                    {
                                        show_carousel &&
                                        <CarouselWithButtons message={bubble_message} btn_disabled />
                                    }
                                </div>
                            </div>
                        </ErrorBoundary>
                    }
                </Col>
                <Col xs={24} sm={24} md={12} className="ori-relative ori-overflow-hidden ori-full-parent-height ori-b-pad-60" >
                    <div className="ori-lr-pad-15 ori-tb-pad-10 ori-full-parent-height ori-overflow-x-hidden ori-overflow-y-auto">
                        <ErrorBoundary type="error" title="Error" message="Something Went Wrong in Form Component">
                            <Form className="ori-json-schema-form-container" schema={schema} uiSchema={ui_schema} formData={form_data} onChange={this.handleFormDataChange} onSubmit={handleOkClick} onError={this.handleFormDataError}>
                                <div className="ori-absolute formFooterContainer">
                                    <ModalFooter loading={loading} button_ok_text={button_ok_text} button_ok_type="submit" handleCancelClick={handleCancelClick} capsule_button />
                                </div>
                            </Form>
                        </ErrorBoundary>
                    </div>
                </Col>
            </Row>
        );
    }
}

BotMessageForm.propTypes = {
    screen_height: PropTypes.number.isRequired,
    screen_width: PropTypes.number.isRequired,
    button_ok_text: PropTypes.string,
    schema: PropTypes.object,
    ui_schema: PropTypes.object,
    form_data: PropTypes.object,
    context_variables_data: PropTypes.object,
    handleOkClick: PropTypes.func,
    handleCancelClick: PropTypes.func,
    updateMessageFormData: PropTypes.func,
    loading: PropTypes.bool,
};

export default BotMessageForm;



// WEBPACK FOOTER //
// ./src/app/pagecontainer/components/botmessageform/index.js